(function () {
  "use strict";
  var doc = document;
  var SEC = "[data-xg-ugc]";
  var FILM = "[data-xg-ugc-film]";
  var STATE = "data-xg-film-state";
  var CLONE = "data-xg-ugc-clone";
  var QUERY = "(prefers-reduced-motion: reduce)";
  var PX_PER_S = 26;
  var NEAR = 120;
  var SWEEP_MS = 400;
  function mq() {
    return typeof window.matchMedia === "function" ? window.matchMedia(QUERY) : null;
  }
  function reduced() {
    var m = mq();
    return !!(m && m.matches);
  }
  function thrifty() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    var t = c.effectiveType || "";
    return t === "slow-2g" || t === "2g";
  }
  function attr(el, name) {
    var v = el.getAttribute(name);
    return v && v.length ? v : null;
  }
  function arm(v) {
    if (v.firstElementChild) return;
    var list = [["data-xg-film-webm", "video/webm"], ["data-xg-film-mp4", "video/mp4"]];
    for (var i = 0; i < list.length; i += 1) {
      var url = attr(v, list[i][0]);
      if (!url) continue;
      var s = doc.createElement("source");
      s.src = url;
      s.type = list[i][1];
      v.appendChild(s);
    }
    if (v.firstElementChild) v.load();
  }
  function hook(v) {
    if (v.__xgUgc) return;
    v.__xgUgc = true;
    v.setAttribute(STATE, "armed");
    v.muted = true;
    v.addEventListener("playing", function () { v.setAttribute(STATE, "playing"); });
    v.addEventListener("error", function () { v.setAttribute(STATE, "still"); }, true);
  }
  function play(v) {
    if (v.getAttribute(STATE) === "still") return;
    arm(v);
    if (!v.firstElementChild || !v.paused) return;
    var p = v.play();
    if (p && typeof p.catch === "function") {
      p.catch(function () { v.setAttribute(STATE, "still"); });
    }
  }
  function halt(v) {
    if (v.firstElementChild && !v.paused) v.pause();
  }
  function setup(sec) {
    if (sec.__xgUgc) return;
    sec.__xgUgc = true;
    var btn = sec.querySelector("[data-xg-ugc-pause]");
    var root = sec.querySelector("[data-xg-scroller]");
    var track = root ? root.querySelector(".xg-scroller") : null;
    var wantsDrift = sec.hasAttribute("data-xg-ugc-marquee");
    var still = reduced();
    var noVideo = still || thrifty();
    var why = {};
    var anim = null;
    var seq = 0;
    var width = 0;
    var timer = 0;
    function paused() {
      for (var k in why) if (why[k]) return true;
      return false;
    }
    function films() { return sec.querySelectorAll(FILM); }
    function sweep() {
      var list = films();
      var vw = window.innerWidth || doc.documentElement.clientWidth;
      var hold = why.user || why.off || noVideo;
      for (var i = 0; i < list.length; i += 1) {
        var v = list[i];
        if (hold) { halt(v); continue; }
        var r = v.getBoundingClientRect();
        var near = r.width > 0 && r.right > -NEAR && r.left < vw + NEAR;
        if (near) play(v); else halt(v);
      }
    }
    function ticking(on) {
      if (on && !timer) {
        sweep();
        timer = window.setInterval(sweep, SWEEP_MS);
      } else if (!on && timer) {
        window.clearInterval(timer);
        timer = 0;
        sweep();
      }
    }
    function originals() {
      var out = [];
      if (!track) return out;
      for (var i = 0; i < track.children.length; i += 1) {
        var li = track.children[i];
        if (!li.hidden && !li.hasAttribute(CLONE)) out.push(li);
      }
      return out;
    }
    var tpl = doc.createElement("template");
    function copy(li) {
      tpl.innerHTML = li.outerHTML;
      var c = tpl.content.firstElementChild;
      var im = c.querySelectorAll("img");
      for (var m = 0; m < im.length; m += 1) {
        if (im[m].hasAttribute("srcset")) im[m].setAttribute("data-xg-ugc-srcset", im[m].getAttribute("srcset"));
        if (im[m].hasAttribute("src")) im[m].setAttribute("data-xg-ugc-src", im[m].getAttribute("src"));
        im[m].removeAttribute("srcset");
        im[m].removeAttribute("src");
      }
      c.setAttribute(CLONE, "");
      c.setAttribute("aria-hidden", "true");
      c.setAttribute("inert", "");
      c.inert = true;
      var vs = c.querySelectorAll(FILM);
      for (var i = 0; i < vs.length; i += 1) {
        while (vs[i].firstChild) vs[i].removeChild(vs[i].firstChild);
        vs[i].removeAttribute(STATE);
      }
      return c;
    }
    function land(frag) {
      track.appendChild(frag);
      var im = track.querySelectorAll("img[data-xg-ugc-src]");
      for (var m = 0; m < im.length; m += 1) {
        var ss = im[m].getAttribute("data-xg-ugc-srcset");
        if (ss) im[m].setAttribute("srcset", ss);
        im[m].setAttribute("src", im[m].getAttribute("data-xg-ugc-src"));
        im[m].removeAttribute("data-xg-ugc-src");
        im[m].removeAttribute("data-xg-ugc-srcset");
      }
    }
    function unbuild() {
      if (anim) { anim.cancel(); anim = null; }
      if (!track) return;
      var cl = track.querySelectorAll("[" + CLONE + "]");
      for (var i = 0; i < cl.length; i += 1) cl[i].remove();
      track.style.removeProperty("overflow");
      track.style.removeProperty("scroll-snap-type");
      track.style.removeProperty("inline-size");
      track.style.removeProperty("will-change");
      root.style.removeProperty("overflow-x");
      root.removeAttribute("data-xg-ugc-drift");
      var nav = root.querySelector(".xg-rail__nav");
      if (nav) nav.style.removeProperty("display");
    }
    function build() {
      if (!wantsDrift || still || !track || typeof track.animate !== "function") return;
      var items = originals();
      if (items.length < 2) return;
      var at = anim ? (anim.currentTime || 0) / (seq / PX_PER_S * 1000) : 0;
      unbuild();
      var clip = window.CSS && CSS.supports && CSS.supports("overflow-x", "clip") ? "clip" : "hidden";
      root.style.setProperty("overflow-x", clip);
      track.style.setProperty("overflow", "visible");
      track.style.setProperty("scroll-snap-type", "none");
      track.style.setProperty("inline-size", "max-content");
      track.style.setProperty("will-change", "transform");
      var nav = root.querySelector(".xg-rail__nav");
      if (nav) nav.style.setProperty("display", "none");
      var frag = doc.createDocumentFragment();
      for (var i = 0; i < items.length; i += 1) frag.appendChild(copy(items[i]));
      land(frag);
      var first = track.querySelector("[" + CLONE + "]");
      seq = first.offsetLeft - items[0].offsetLeft;
      if (seq <= 0) { unbuild(); return; }
      var sets = Math.max(1, Math.ceil(root.clientWidth / seq));
      for (var s = 1; s < sets; s += 1) {
        frag = doc.createDocumentFragment();
        for (var j = 0; j < items.length; j += 1) frag.appendChild(copy(items[j]));
        land(frag);
      }
      var cl = track.querySelectorAll(FILM);
      for (var k = 0; k < cl.length; k += 1) if (!noVideo) hook(cl[k]);
      var dur = seq / PX_PER_S * 1000;
      anim = track.animate(
        [{ transform: "translate3d(0,0,0)" }, { transform: "translate3d(" + (-seq) + "px,0,0)" }],
        { duration: dur, iterations: Infinity, easing: "linear" }
      );
      anim.currentTime = (at % 1) * dur;
      root.setAttribute("data-xg-ugc-drift", "");
      width = root.clientWidth;
      if (paused()) anim.pause();
    }
    function settle() {
      if (anim) {
        if (paused()) anim.pause();
        else anim.play();
      }
      ticking(!why.off && !why.user && !noVideo);
      if (btn) {
        var label = btn.querySelector(".xg-btn__label") || btn;
        label.textContent = why.user
          ? (btn.getAttribute("data-xg-ugc-play-label") || "Play clips")
          : (btn.getAttribute("data-xg-ugc-pause-label") || "Pause clips");
      }
    }
    if (root) {
      root.addEventListener("mouseenter", function () { why.hover = true; settle(); });
      root.addEventListener("mouseleave", function () { why.hover = false; settle(); });
      root.addEventListener("focusin", function () { why.focus = true; settle(); });
      root.addEventListener("focusout", function (e) {
        if (e.relatedTarget && root.contains(e.relatedTarget)) return;
        why.focus = false;
        settle();
      });
      var lift = 0;
      root.addEventListener("pointerdown", function (e) {
        if (e.pointerType === "mouse") return;
        window.clearTimeout(lift);
        why.touch = true;
        settle();
      });
      var release = function (e) {
        if (e.pointerType === "mouse") return;
        window.clearTimeout(lift);
        lift = window.setTimeout(function () { why.touch = false; settle(); }, 2500);
      };
      root.addEventListener("pointerup", release);
      root.addEventListener("pointercancel", release);
    }
    if (btn) {
      btn.addEventListener("click", function () {
        why.user = !why.user;
        settle();
      });
    }
    why.off = true;
    if (typeof window.IntersectionObserver === "function") {
      new IntersectionObserver(function (entries) {
        why.off = !entries[entries.length - 1].isIntersecting;
        settle();
      }, { rootMargin: "200px 0px" }).observe(sec);
    } else {
      why.off = false;
    }
    var own = films();
    for (var i = 0; i < own.length; i += 1) {
      if (noVideo) own[i].setAttribute(STATE, "still");
      else hook(own[i]);
    }
    build();
    var pending = false;
    window.addEventListener("resize", function () {
      if (pending || !anim) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        if (root && root.clientWidth !== width) build();
      });
    }, { passive: true });
    var m = mq();
    if (m) {
      var onChange = function () {
        if (!m.matches) return;
        still = true;
        noVideo = true;
        unbuild();
        ticking(false);
        var list = films();
        for (var j = 0; j < list.length; j += 1) {
          halt(list[j]);
          list[j].setAttribute(STATE, "still");
        }
        if (btn) btn.hidden = true;
      };
      if (m.addEventListener) m.addEventListener("change", onChange);
      else if (m.addListener) m.addListener(onChange);
    }
    if (btn && (anim || !noVideo)) btn.hidden = false;
    settle();
  }
  function init(scope) {
    var s = scope && scope.querySelectorAll ? scope : doc;
    var list = s.matches && s.matches(SEC) ? [s] : s.querySelectorAll(SEC);
    for (var i = 0; i < list.length; i += 1) setup(list[i]);
  }
  init(doc);
  doc.addEventListener("shopify:section:load", function (e) { init(e.target); });
  window.XG = window.XG || {};
  window.XG.ugc = { init: init };
})();
